import React from 'react';
import TradeObject from '../trade-object';

const TradeDetails = ({ messages, data, langCode }) => (

  <div className="trade-object-container trade-order">
    {data && data.map(object => (
      <TradeObject
        id={`${object.key}`}
        title={messages[object.titleId]}
        value={(object.value && object.value !== null) ? object.value : ''}
        currency={object.code}
        type={object.type}
        langCode={langCode}
        popoverText={(object.showTooltip && object.content) ? object.content : null}
        border
        showTooltip={object.showTooltip}
        size={object.size}
      />
    ))
    }
  </div>
)

export default TradeDetails;
